module.exports = __webpack_public_path__ + "static/media/manabi_banner_zh.36c78e93.png";